/**
 * Session cookies live on the whole app. Without an explicit path the browser
 * scopes a cookie to the current route's directory, so a cookie set on
 * `/login` (path `/`) could not be deleted from `/seller-portal/...`.
 */
export const SESSION_COOKIE_PATH = '/';
